<template>
    <vx-expandable-card class="mb-4">
        <template v-slot:header>Pricing & Commitments</template>
        <template v-slot:content>
            <div class="flex flex-col items-center justify-center py-8 text-center">
                <div class="text-gray-400 mb-3">
                    <font-awesome-icon :icon="faCircleInfo" class="text-3xl" widthAuto />
                </div>
                <p class="text-sm font-medium text-gray-700 mb-1">Usage Allocation Coming Soon</p>
                <p class="text-xs text-gray-500 max-w-xs">
                    The ability to allocate usage to groups is not yet available. This will be enabled in a future
                    update.
                </p>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
</script>
